import { render, staticRenderFns } from "./DirectoryModalForm.vue?vue&type=template&id=906dbe8e"
import script from "./DirectoryModalForm.vue?vue&type=script&lang=js"
export * from "./DirectoryModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports